var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    d: "M11.542 3.731h-.049c-3.256-.328-6.505-.452-9.724-.124l-1.256.124a.466.466 0 0 1-.51-.421.461.461 0 0 1 .412-.509l1.255-.124c3.274-.335 6.592-.204 9.915.124a.465.465 0 0 1 .413.509.457.457 0 0 1-.456.421Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    d: "M3.849 3.105c-.025 0-.05 0-.08-.006a.467.467 0 0 1-.376-.533l.136-.813c.098-.595.234-1.42 1.668-1.42h1.612c1.44 0 1.576.856 1.668 1.426l.136.807a.46.46 0 1 1-.905.155l-.136-.807c-.086-.54-.104-.645-.757-.645H5.203c-.653 0-.665.087-.757.64l-.142.805a.463.463 0 0 1-.455.391ZM7.979 13.667H4.027c-2.148 0-2.234-1.197-2.302-2.165l-.4-6.245a.468.468 0 0 1 .431-.496.468.468 0 0 1 .493.434l.4 6.245c.067.943.092 1.297 1.378 1.297H7.98c1.292 0 1.317-.354 1.378-1.296l.4-6.246a.471.471 0 0 1 .493-.434c.252.019.45.236.43.496l-.4 6.245c-.067.968-.153 2.165-2.301 2.165Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    d: "M7.025 10.255h-2.05a.467.467 0 0 1-.461-.465c0-.254.209-.465.461-.465h2.05c.252 0 .461.211.461.465 0 .255-.209.465-.461.465ZM7.542 7.775H4.465a.467.467 0 0 1-.462-.465c0-.254.21-.465.462-.465h3.077c.252 0 .462.21.462.465 0 .254-.21.465-.462.465Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbin);
export default __webpack_public_path__ + "static/media/trashbin.3ab24bbd06e65a7d4c166980bcfe5acc.svg";
export { ForwardRef as ReactComponent };